import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';

import { useDispatch } from 'react-redux';

import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { handlePostRequest } from '../../service/PostTemplate';

const SettlementSummary = () => {
    const [allRoles, setAllRoles] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);

    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();
    const formik = useFormik({
        // validationSchema: validationSchema,
        initialValues: {
            id: '',
            customerName: '',
            createdBy: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            setLoadingBtn(true);
            const addData = {
                roleName: data.roleName,
                createdBy: user?.user?.userId
            };

            const editData = {
                id: data.id,
                roleName: data.roleName,
                modifiedBy: user?.user?.userId
            };

            const response = await dispatch(handlePostRequest(addData, endPoints.addRole, true));
            if (response?.status === 200) {
                formik.resetForm();
                //   onHide();
            }
            setLoadingBtn(false);
        }
    });

    const getRoleList = async () => {
        const response = await handleGetRequest(endPoints.getallRoles, true, false, dispatch);
        if (response) {
            setAllRoles(response);
        }
    };

    useEffect(() => {
        getRoleList();
    }, []);

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];
    return (
        <div className="p-4">
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">Start Date</label>
                                <InputText id="dateTo" type="date" name="dateTo" max={previousDate} value={formik?.values?.dateTo || ''} onChange={formik.handleChange} />

                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName"> End Date</label>
                                <InputText id="dateTo" type="date" name="dateTo" max={previousDate} value={formik?.values?.dateTo || ''} onChange={formik.handleChange} />

                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>

                        <div className="live__SearchBtn p-field col-12 md:col-12">
                            {/* <Button disabled={loading} loadingIcon={loadingIcon} icon={loadingIcon} iconPos="left" label="Search" className="Btn__Dark__Search" /> */}
                            <Button label="Search" icon="pi pi-search" className="Btn__Dark__Search" />

                            <Button
                                label="Reset"
                                // onClick={(e) => resetHandle(e)}
                                className="Btn__Transparent__Reset"
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className="Form__Header mt-5">
                <p className="text-2xl font-medium">Settlement Summary</p>
            </div>
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={15}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                            emptyMessage="No List found."
                            responsiveLayout="scroll"
                            value={[]}
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="lkpPartner.partnerName" header="Transaction Count " />

                            <Column field="roleCode" header="Transaction Amount" />

                            <Column field="email" header="APPS Charges" />
                            <Column field="email" header="Tax On APPS Charges" />
                            <Column field="email" header="Deductions" />
                            <Column field="email" header="Refund/Adjusments" />
                            <Column field="email" header="Merchant Amount" />
                            <Column field="email" header="Account No." />

                            <Column field="email" header="Bank Name" />
                            <Column field="email" header="Beneficiary Name" />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettlementSummary;
